import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home/block1-搜索.png")